export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/graph.worker.b590f53f.worker.js");
}
